/**
 * Gets navigationItems list that current user has access to.
 */
export function getNavigationItemsForUser(appSections, sidebarNavigationItems, userHasAccessTo) {
    if (userHasAccessTo({ claims: ['Admin'], groups: undefined })) {
        return sidebarNavigationItems;
    }
    const result = sidebarNavigationItems.map(({ menuItems, ...group }) => ({
        ...group,
        menuItems: menuItems.filter((sectionKey) => userHasAccessTo({ groups: appSections[sectionKey].groups })),
    }));
    return result.filter((item) => item.menuItems.length > 0);
}
